import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import React from 'react'

export const NavBarIndicator = ({children}) => {
    const location = useLocation();
    const [showNavBar,setShowNavBar] = useState(false);

    useEffect(() => {
        // console.log(location)
        if (location.pathname ==='/login') {
            setShowNavBar(false);
        } else {
            setShowNavBar(true);
        };
    },[location])

    return (
        <div>{showNavBar && children}</div>
    )
}
